import { render, staticRenderFns } from "./migrationjaminan.vue?vue&type=template&id=81380040&scoped=true&"
import script from "./migrationjaminan.vue?vue&type=script&lang=js&"
export * from "./migrationjaminan.vue?vue&type=script&lang=js&"
import style0 from "./migrationjaminan.vue?vue&type=style&index=0&id=81380040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81380040",
  null
  
)

export default component.exports